module.exports = __webpack_public_path__ + "static/media/ZGO__i3_sm2.2e75a3f4.png";